import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Check, Laptop, Moon, Sparkles, Sun } from 'lucide-react';
import { createElement } from 'react';
import { useTheme } from '../providers';
import { cn } from '@/lib/utils';
import { SidebarMenuButton } from '../ui/sidebar';

/** Theme dropdown */
export function ThemeDropdown({ className }: { className?: string }) {
  const { setTheme, theme } = useTheme();

  const icon = theme === 'dark' ? Moon : theme === 'light' ? Sun : Laptop;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <SidebarMenuButton
          tooltip="Appearance"
          className={cn(
            className,
            'hover:bg-transparent active:bg-transparent focus:bg-transparent',
            'data-[state=open]:bg-transparent'
          )}
        >
          <Sparkles className="h-5 w-5 shrink-0" />

          {/* hide label when collapsed */}
          <span className="group-data-[collapsible=icon]:hidden">
            Appearance
          </span>

          {/* right icon only when expanded (optional) */}
          <span className="ml-auto group-data-[collapsible=icon]:hidden">
            {createElement(icon, { className: 'h-4 w-4 opacity-80' })}
          </span>
        </SidebarMenuButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" className="w-[260px]">
        <DropdownMenuLabel>Theme</DropdownMenuLabel>
        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={() => setTheme('system')} className="gap-2">
          <Laptop className="h-4 w-4" />
          System
          {theme === 'system' && <Check className="ml-auto h-4 w-4" />}
        </DropdownMenuItem>

        <DropdownMenuItem onClick={() => setTheme('light')} className="gap-2">
          <Sun className="h-4 w-4" />
          Light
          {theme === 'light' && <Check className="ml-auto h-4 w-4" />}
        </DropdownMenuItem>

        <DropdownMenuItem onClick={() => setTheme('dark')} className="gap-2">
          <Moon className="h-4 w-4" />
          Dark
          {theme === 'dark' && <Check className="ml-auto h-4 w-4" />}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
